const base = process.env.PUBLIC_URL || "";

export const assetPath = (filename) => `${base}/assets/${filename}`;

export const assets = {
  logo: assetPath("logo.png"),
  heroBg: assetPath("hero-bg.jpg"),
  aboutLab: assetPath("about-lab.jpg"),
  whyPartnerFactory: assetPath("factory.jpg"),
  qualityLab: assetPath("quality-lab.jpg"),
  gutproMaxBrochure: assetPath("gutpro-max-brochure.jpg"),
  monensinPremixLiterature: assetPath("monensin-premix-literature.pdf"),
  salinomycinPremixLiterature: assetPath("salinomycin-premix-literature.pdf"),
  diclazurilPremixLiterature: assetPath("diclazuril-premix-literature.pdf"),
  nicarbazinePremixLiterature: assetPath("nicarbazine-premix-literature.pdf"),
};
